export const isMobileDevice = (): boolean => {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1 ||
    navigator.userAgent.indexOf('Mobile') !== -1
  );
};

export default { isMobileDevice };
